@if (isAvailable()) {
  <div class="apple-pay-button-wrapper">
    <button
      type="button"
      class="apple-pay-button"
      [class.apple-pay-button--disabled]="disabled() || isProcessing()"
      [disabled]="disabled() || isProcessing()"
      (click)="onApplePayClick()"
      aria-label="Pay with Apple Pay"
    ></button>

    @if (isProcessing()) {
      <div class="apple-pay-button-wrapper__processing">
        Processing...
      </div>
    }

    @if (error()) {
      <div class="apple-pay-button-wrapper__error">
        {{ error() }}
      </div>
    }
  </div>
}
